export default __webpack_public_path__ + "static/media/_DSC0085.e439b53b.jpg";